const API_BASE = process.env.REACT_APP_API_BASE || '/api';

async function post(path, body) {
  // Ensure API_BASE doesn't end with slash and path starts with slash
  const baseUrl = API_BASE.endsWith('/') ? API_BASE.slice(0, -1) : API_BASE;
  const cleanPath = path.startsWith('/') ? path : `/${path}`;
  const res = await fetch(`${baseUrl}${cleanPath}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body)
  });
  const json = await res.json().catch(() => ({}));
  if (!res.ok || json.ok === false) {
    const message = (json && (json.error || json.message)) || 'Request failed';
    throw new Error(message);
  }
  return json;
}

async function get(path, options = {}) {
  // Ensure API_BASE doesn't end with slash and path starts with slash
  const baseUrl = API_BASE.endsWith('/') ? API_BASE.slice(0, -1) : API_BASE;
  const cleanPath = path.startsWith('/') ? path : `/${path}`;
  
  // Build URL - handle both absolute and relative URLs
  let urlString = `${baseUrl}${cleanPath}`;
  
  // Add cache-busting parameter for webinar data
  if (path === '/webinar-data') {
    const separator = urlString.includes('?') ? '&' : '?';
    urlString = `${urlString}${separator}t=${Date.now()}`;
  }
  
  const res = await fetch(urlString, {
    headers: {
      'Cache-Control': 'no-cache, no-store, must-revalidate',
      'Pragma': 'no-cache',
      'Expires': '0',
      ...options.headers
    },
    ...options
  });
  
  const json = await res.json().catch(() => ({}));
  if (!res.ok || json.ok === false) {
    const message = (json && (json.error || json.message)) || 'Request failed';
    throw new Error(message);
  }
  return json;
}

export const api = {
  leadMagnet: (data) => post('/lead-magnet', data),
  contact: (data) => post('/contact', data),
  booking: (data) => post('/booking', data),
  getAvailableSlots: (date, type) => get(`/booking/available-slots?date=${date}&type=${encodeURIComponent(type || '')}`),
  newsletter: (data) => post('/newsletter', data),
  webinar: (data) => post('/webinar', data),
  webinarRegistration: (data) => post('/webinar-registration', data),
  registration: (data) => post('/registration', data),
  getWebinarData: () => get('/webinar-data'),
  getEventsData: () => get('/events-data'),
  getHealthStatus: () => get('/health')
};
